<template lang="pug">
  b-modal#addProvider(
  ref="addProvider"
  :title="$t('ui.combine.add_provider')"
  centered
  no-fade
  no-close-on-backdrop
  :busy="loading"
  @ok="done"
  @show="reset"
  @shown="shown")
    b-form(novalidate :disabled="!feedback.success" @submit.stop.prevent="submit")
      b-form-group(:label="$t('ui.id')").mb-0
        DebounceInput(
          size="sm"
          ref="dataAdd_providerId"
          required
          alphaNum
          type="text"
          :dirty="$v.dataAdd_providerId.$dirty"
          :error="$v.dataAdd_providerId.$error"
          v-model.trim.lazy="$v.dataAdd_providerId.$model"
          :disabled="loading"
          :maxLength="$v.dataAdd_providerId.$params.maxLength.max"
        )
        ValidateResult(:value="$v.dataAdd_providerId" :name="$t('ui.id')")
      b-form-group(:label="$t('ui.name')").mb-0
        DebounceInput(
          size="sm"
          required
          type="text"
          :dirty="$v.dataAdd_providerName.$dirty"
          :error="$v.dataAdd_providerName.$error"
          v-model.trim.lazy="$v.dataAdd_providerName.$model"
          :disabled="loading"
          :maxLength="$v.dataAdd_providerName.$params.maxLength.max"
        )
        ValidateResult(:value="$v.dataAdd_providerName" :name="$t('ui.name')")
      div.row
        div.col
          b-alert.animated.flash(:show="!feedback.success" variant="bottom") {{ $t("error." + feedback.status) }}
    div(slot="modal-cancel")
      SubmitButton(:loading="loading" icon="fa fa-ban" :text="$t('ui.cancel')" isModal=true)
    div(slot="modal-ok")
      SubmitButton(:loading="loading" icon="fa fa-save" :text="$t('ui.save')" isModal=true)
</template>

<script>
import { required, alphaNum, minLength, maxLength } from "vuelidate/lib/validators";
import config from "@/config";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton";
import ValidateResult from "@/library/ValidateResult";
import DebounceInput from "@/library/DebounceInput";

export default {
  components: {
    SubmitButton,
    ValidateResult,
    DebounceInput
  },
  data() {
    return {
      dataAdd_providerId: "",
      dataAdd_providerName: "",
      loading: false,
      feedback: {
        success: true,
        status: ""
      }
    };
  },
  validations: {
    dataAdd_providerId: {
      required,
      alphaNum,
      minLength: minLength(3),
      maxLength: maxLength(3)
    },
    dataAdd_providerName: {
      required,
      minLength: minLength(2),
      maxLength: maxLength(50)
    }
  },
  methods: {
    done: function(evt) {
      evt.preventDefault();
      this.submit();
    },
    submit: function() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        let url = config.addProviderUrl();

        var json = {
          action_by: this.$store.getters.username,
          session_token: this.$store.getters.sessionToken,
          page_id: config.accessRoles.provider,
          provider_id: this.dataAdd_providerId,
          provider_name: this.dataAdd_providerName
        };

        this.feedback.success = true;
        this.loading = true;
        this.$http.post(url, json).then(
          function(response) {
            this.loading = false;
            // Success
            try {
              if (response) {
                if (typeof response.data.status == "string") {
                  this.feedback.success = response.data.status == "1";
                } else {
                  this.feedback.success = response.data.status == 1;
                }
                this.feedback.status = response.data.statusdesc;
                if (this.feedback.success == true) {
                  this.$emit("clicked", this.dataAdd_providerId, this.dataAdd_providerName);
                  this.$refs.addProvider.hide();
                } else {
                  this.$helpers.handleFeedback(this.feedback.status);
                  this.$emit("failed", "add_provider", this.feedback.status);
                  this.$refs.addProvider.hide();
                }
              }
            } catch (error) {
              this.feedback.success = false;
              this.feedback.status = errorTags.request.failed;
            }
          },
          function(response) {
            this.loading = false;
            // Error
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
          }
        );
      }
    },
    reset: function() {
      this.dataAdd_providerId = "";
      this.dataAdd_providerName = "";
      this.feedback.success = true;
      this.feedback.status = "";
    },
    shown: function() {
      this.$v.$reset();
      this.$refs.dataAdd_providerId.$el.focus();
    }
  }
};
</script>
